'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCloud = function MdCloud(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.3 16.7q3.2 0.3 5.4 2.6t2.3 5.7q0 3.4-2.5 5.9t-5.9 2.5h-21.6q-4.1 0-7.1-3t-2.9-7q0-3.9 2.6-6.7t6.3-3.3q1.6-3 4.6-4.9t6.5-1.9q4.5 0 8 2.9t4.3 7.2z' })
        )
    );
};

exports.default = MdCloud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/cloud.js
// module id = 3190
// module chunks = 168707334958949